import React from 'react';
import { useSelector } from 'react-redux';
import SubMenu from 'theme/sub-menu';
import translations from 'translations';

function TopNav({ activeKey = 'panoramic' }) {
  const { languageCode } = useSelector((state) => state.config);

  return (
    <SubMenu
      activeKey={activeKey}
      languageCode={languageCode}
      options={[
        {
          key: 'panoramic',
          title: translations[languageCode].panoramic,
          href: '/billing',
        },
        {
          key: 'profiles',
          title: translations[languageCode].profiles,
          href: '/billing/profiles',
        },
        {
          key: 'documents',
          title: translations[languageCode].documents,
          href: '/billing/documents',
        },
        {
          key: 'reports',
          title: translations[languageCode].reports,
          href: '/billing/reports',
        },
      ]}
    />
  );
}

export default TopNav;
